// v36 — pomocníci k mriežke odznakov.
//
// Odznaky „na počet" (majú `target` a nameranú hodnotu `value` z /api/state) ukazujú v miniatúre
// prúžok pokroku. Kreslí sa LEN pri tom odznaku z rodiny (kategórie), ktorý je najbližšie
// k získaniu — inak by bola mriežka pás prúžkov a nebolo by vidieť, na čom sa reálne pracuje.
// Vedľajší efekt, ktorý je na veľkej mriežke podstatný: jeden prúžok na kategóriu, nie ~50.

export type BadgeLike = {
  code: string;
  earned?: boolean;
  tier?: number | null;
  target?: number | null;
  value?: number | null;
};

/** Percento naplnenia odznaku, alebo null, keď sa prúžok nemá kresliť (získaný / bez cieľa). */
export function badgeProgressPct(b: BadgeLike): number | null {
  if (b.earned || b.target == null || b.value == null) return null;
  return Math.max(0, Math.min(100, (100 * b.value) / Math.max(1, b.target)));
}

/**
 * Kód odznaku z rodiny, ktorý je najbližšie k získaniu = najvyššie percento naplnenia.
 * Pri zhode vyhráva nižší tier (skôr sa získa). Žiadny kandidát → null.
 *
 * Zámerne sa neberie „najnižší nezískaný tier": ciele síce v rodine rastú, ale keď sa niektorý
 * odznak preskočí (prekódovanie, spätné doudelenie), percento je pravdivejšia miera blízkosti.
 */
export function closestBadgeCode(items: BadgeLike[]): string | null {
  let best: BadgeLike | null = null;
  let bestPct = -1;
  for (const b of items) {
    const p = badgeProgressPct(b);
    if (p == null) continue;
    if (p > bestPct || (p === bestPct && (b.tier || 0) < (best!.tier || 0))) { best = b; bestPct = p; }
  }
  return best ? best.code : null;
}
